<script setup lang="ts">
import { computed, ref } from 'vue'
import { NetworkListItem } from 'wepin-vue-component'
import { defaultCoinIcon } from '@/const'

const props = withDefaults(
  defineProps<{
    ticker?: string
    symbol?: string
    networkSrc?: string
    address?: string
    selected?: boolean
    width?: string
  }>(),
  {
    ticker: '',
    symbol: '',
    networkSrc: '',
    address: '',
    selected: false,
    width: '400px',
  },
)

const isErrorLoadTokenIcon = ref(false)
const onErrorLoadTokenIcon = () => {
  isErrorLoadTokenIcon.value = true
}

const getIconUrl = computed(() => {
  if (isErrorLoadTokenIcon.value) {
    return defaultCoinIcon
  }
  return props.networkSrc
})
</script>

<template>
  <NetworkListItem
    :ticker="ticker"
    :symbol="symbol"
    :network-src="getIconUrl"
    :address="address"
    :selected="selected"
    :width="width"
    @error:load-token-icon="onErrorLoadTokenIcon"
  />
</template>
